var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenseAnalyticsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 368,
    viewBox: "0 0 438 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7388 71.8188C92.1287 71.8188 96.498 67.4469 96.498 62.0539C96.498 56.661 92.1287 52.2891 86.7388 52.2891C81.349 52.2891 76.9796 56.661 76.9796 62.0539C76.9796 67.4469 81.349 71.8188 86.7388 71.8188Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.832 101.627C359.222 101.627 363.592 97.2555 363.592 91.8625C363.592 86.4696 359.222 82.0977 353.832 82.0977C348.443 82.0977 344.073 86.4696 344.073 91.8625C344.073 97.2555 348.443 101.627 353.832 101.627Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.514 38.6698C108.642 38.6698 110.366 36.944 110.366 34.8152C110.366 32.6864 108.642 30.9607 106.514 30.9607C104.386 30.9607 102.662 32.6864 102.662 34.8152C102.662 36.944 104.386 38.6698 106.514 38.6698Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342.532 60.2552C344.802 60.2552 346.641 58.4144 346.641 56.1437C346.641 53.873 344.802 52.0322 342.532 52.0322C340.263 52.0322 338.423 53.873 338.423 56.1437C338.423 58.4144 340.263 60.2552 342.532 60.2552Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.231 290.5C296.242 290.5 359.483 227.223 359.483 149.167C359.483 71.1105 296.242 7.83339 218.231 7.83339C140.22 7.83339 76.9796 71.1105 76.9796 149.167C76.9796 227.223 140.22 290.5 218.231 290.5Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.782 230.112L135.021 279.707C132.967 280.478 130.655 279.45 129.885 277.652L59.2589 102.141C58.4885 100.086 59.5158 97.7728 61.3135 97.0019L184.074 47.4068C186.128 46.6359 188.44 47.6638 189.21 49.4626L259.836 224.716C260.863 227.029 259.836 229.341 257.782 230.112Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.592 126.296L100.864 167.669C99.8367 168.182 98.8094 167.669 98.2957 166.641C97.7821 165.613 98.2957 164.585 99.323 164.071L201.795 122.699C202.822 122.185 203.849 122.699 204.363 123.727C204.876 124.755 204.363 125.782 203.592 126.296Z",
    fill: "#E6EDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.445 136.318L104.973 177.69C103.946 178.204 102.919 177.69 102.405 176.662C101.891 175.635 102.405 174.607 103.432 174.093L205.904 132.721C206.931 132.207 207.959 132.721 208.472 133.749C208.986 134.776 208.472 135.804 207.445 136.318Z",
    fill: "#E6EDF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.554 146.083L109.082 187.712C108.055 188.226 107.027 187.712 106.514 186.684C106 185.656 106.514 184.629 107.541 184.115L210.013 142.742C211.04 142.229 212.067 142.742 212.581 143.77C213.094 144.541 212.581 145.826 211.554 146.083Z",
    fill: "#E6EDF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.714 182.059L113.191 197.734C112.164 198.248 111.137 197.734 110.623 196.706C110.109 195.678 110.623 194.65 111.65 194.136L150.174 178.461C151.201 177.947 152.228 178.461 152.742 179.489C152.999 180.517 152.742 181.545 151.714 182.059Z",
    fill: "#E6EDF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M224.908 171.523L228.247 180.003C228.761 181.545 228.247 183.344 226.706 183.858L125.262 224.973C123.721 225.487 121.923 224.973 121.41 223.431L118.071 214.694C117.557 213.152 118.071 211.353 119.612 210.839L221.056 169.981C222.597 169.467 224.138 170.238 224.908 171.523Z",
    fill: "#E3EAF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M232.87 191.053L236.209 199.533C236.722 201.075 236.209 202.873 234.668 203.387L133.224 244.502C131.683 245.016 129.885 244.502 129.371 242.961L125.776 234.224C125.262 232.682 125.776 230.883 127.317 230.369L228.761 189.511C230.302 188.997 232.1 189.768 232.87 191.053Z",
    fill: "#E3EAF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.574 210.582L243.913 219.062C244.427 220.604 243.913 222.403 242.372 222.917L140.928 264.032C139.387 264.546 137.589 264.032 137.076 262.49L133.737 254.01C133.223 252.469 133.737 250.67 135.278 250.156L236.722 209.298C238.263 208.527 240.061 209.298 240.574 210.582Z",
    fill: "#E3EAF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 206.728L135.792 220.861L125.262 224.973C123.721 225.487 121.923 224.973 121.41 223.431L118.071 214.694C117.557 213.152 118.071 211.353 119.612 210.839L130.141 206.728Z",
    fill: "#7647EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.573 230.369L158.392 217.778L164.042 231.911L133.223 244.502C131.682 245.016 129.885 244.502 129.371 242.961L125.775 234.224C125.262 232.939 126.032 231.14 127.573 230.369Z",
    fill: "#FD561F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.278 249.899L139.644 248.1L145.294 262.233L140.928 264.032C139.387 264.546 137.589 264.032 137.076 262.49L133.737 254.01C133.223 252.469 133.737 250.67 135.278 249.899Z",
    fill: "#F7AD3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.819 117.559C136.562 103.426 125.005 91.8625 110.623 91.8625H110.366C95.9844 91.8625 84.4275 103.683 84.4275 118.073C84.6843 132.464 96.4981 144.027 110.88 144.027C118.841 144.027 125.776 140.43 130.655 135.033C134.764 130.408 137.076 124.498 137.076 117.816C136.819 117.816 136.819 117.816 136.819 117.559ZM110.88 135.804C101.121 135.804 93.1594 127.838 93.1594 118.073C93.1594 108.309 101.121 100.342 110.88 100.342H111.137C120.896 100.342 128.601 108.052 128.858 117.559C128.858 117.816 128.858 117.816 128.858 118.073C128.858 122.442 127.317 126.553 124.492 129.637C120.896 133.492 116.273 135.804 110.88 135.804Z",
    fill: "#E6EDF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.819 117.559H128.344C128.344 108.052 120.383 100.342 110.88 100.342H110.623V91.8625H110.88C125.005 91.8625 136.562 103.426 136.819 117.559Z",
    fill: "#FD561F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_34_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.861 269.942L183.817 223.688C181.762 222.917 180.735 220.604 181.506 218.549L247.252 41.4965C248.022 39.4407 250.334 38.4128 252.388 39.1837L376.433 85.1813C378.487 85.9522 379.514 88.2649 378.744 90.3207L312.998 267.63C312.227 269.685 309.916 270.713 307.861 269.942Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M291.425 118.844L281.409 114.99L289.627 92.1195L299.643 95.7171L291.425 118.844Z",
    fill: "#E6EDF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M305.036 123.727L294.763 119.872L307.348 84.9242L317.364 88.7787L305.036 123.727Z",
    fill: "#7647EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.003 133.234L321.987 129.637L338.423 83.6393L348.696 87.2369L332.003 133.234Z",
    fill: "#7647EE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M344.844 137.86L334.828 134.262L339.194 121.671L349.467 125.525L344.844 137.86Z",
    fill: "#E6EDF5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M337.653 156.619L233.897 118.073C232.87 117.816 232.356 116.532 232.613 115.504C232.87 114.476 234.154 113.962 235.181 114.219L338.937 152.764C339.964 153.021 340.478 154.306 340.221 155.334C339.707 156.362 338.68 156.876 337.653 156.619Z",
    fill: "#E6EDF5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M333.8 166.641L230.045 128.095C229.017 127.838 228.504 126.553 228.761 125.525C229.017 124.498 230.301 123.984 231.329 124.241L335.084 162.786C336.112 163.043 336.625 164.328 336.368 165.356C336.112 166.384 334.828 167.155 333.8 166.641Z",
    fill: "#E6EDF5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M330.205 176.662L226.449 138.117C225.422 137.86 224.908 136.575 225.165 135.547C225.422 134.519 226.706 134.005 227.733 134.262L331.489 172.808C332.516 173.065 333.03 174.35 332.773 175.378C332.259 176.662 331.232 177.176 330.205 176.662Z",
    fill: "#E6EDF5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M261.891 162.786L222.854 148.396C221.827 148.139 221.313 146.854 221.57 145.826C221.827 144.798 223.111 144.284 224.138 144.541L263.175 158.932C264.202 159.188 264.716 160.473 264.459 161.501C263.945 162.529 262.918 163.043 261.891 162.786Z",
    fill: "#DDDDDD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323.014 204.415L319.932 213.152C319.419 214.694 317.621 215.465 316.08 214.951L293.993 206.728L213.351 176.662C211.811 176.149 211.04 174.35 211.554 172.808L214.636 164.071C215.149 162.529 216.947 161.758 218.488 162.272L298.616 192.081L320.959 200.304C322.757 201.332 323.528 202.873 323.014 204.415Z",
    fill: "#E6EDF5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M315.566 224.202L312.484 232.939C311.971 234.481 310.173 235.252 308.632 234.738L301.184 231.911L206.16 196.706C204.619 196.192 203.849 194.393 204.363 192.852L207.444 184.115C207.958 182.573 209.756 181.802 211.297 182.316L306.577 217.778L313.768 220.604C315.309 221.118 316.08 222.66 315.566 224.202Z",
    fill: "#E6EDF5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.375 243.988L305.293 252.725C304.78 254.267 302.982 255.038 301.441 254.524L263.431 240.391L198.969 216.493C197.428 215.979 196.658 214.18 197.172 212.638L200.253 203.901C200.767 202.359 202.565 201.588 204.106 202.102L270.109 226.514L306.577 240.134C308.118 240.648 308.889 242.447 308.375 243.988Z",
    fill: "#E6EDF5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.106 202.102L270.109 226.514L263.431 240.134L198.969 216.236C197.428 215.722 196.658 213.923 197.172 212.381L200.253 203.644C200.767 202.359 202.565 201.588 204.106 202.102Z",
    fill: "#7647EE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.554 173.065L214.636 164.328C215.149 162.786 216.947 162.015 218.488 162.529L298.616 192.338L293.48 206.471L213.351 176.662C211.811 176.149 211.04 174.607 211.554 173.065Z",
    fill: "#19AE57"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.577 217.778L301.184 231.911L206.16 196.706C204.619 196.192 203.849 194.393 204.363 192.852L207.444 184.115C207.958 182.573 209.756 181.802 211.297 182.316L306.577 217.778Z",
    fill: "#19AE57"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M237.749 169.724L232.613 183.858L213.351 176.662C211.811 176.149 211.04 174.35 211.554 172.808L214.636 164.071C215.149 162.529 216.947 161.758 218.488 162.272L237.749 169.724Z",
    fill: "#DDDDDD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M211.297 182.316L230.558 189.511L225.422 203.644L206.16 196.449C204.619 195.935 203.849 194.136 204.363 192.595L207.444 183.858C208.215 182.573 209.756 181.802 211.297 182.316Z",
    fill: "#DDDDDD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M204.106 202.102L223.367 209.298L218.231 223.431L198.969 216.236C197.428 215.722 196.658 213.923 197.172 212.381L200.253 203.644C200.767 202.359 202.565 201.588 204.106 202.102Z",
    fill: "#DDDDDD"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_34_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.775 227.029H153.512C151.458 227.029 149.66 225.23 149.66 223.174V34.0444C149.66 31.9886 151.458 30.1898 153.512 30.1898H285.775C287.83 30.1898 289.627 31.9886 289.627 34.0444V222.917C289.884 225.23 288.086 227.029 285.775 227.029Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274.218 102.91H163.785C162.758 102.91 161.731 102.139 161.731 100.855C161.731 99.8279 162.501 98.8006 163.785 98.8006H274.218C275.245 98.8006 276.273 99.5711 276.273 100.855C276.273 101.882 275.245 102.91 274.218 102.91Z",
    fill: "#E6EDF5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M274.218 113.446H163.785C162.758 113.446 161.731 112.675 161.731 111.391C161.731 110.364 162.501 109.336 163.785 109.336H274.218C275.245 109.336 276.273 110.107 276.273 111.391C276.273 112.675 275.245 113.446 274.218 113.446Z",
    fill: "#E6EDF5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.218 124.238H163.785C162.758 124.238 161.731 123.468 161.731 122.184C161.731 121.156 162.501 120.129 163.785 120.129H274.218C275.245 120.129 276.273 120.9 276.273 122.184C276.273 123.468 275.245 124.238 274.218 124.238Z",
    fill: "#E6EDF5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M273.961 164.582H236.722C235.695 164.582 234.668 163.812 234.668 162.528C234.668 161.501 235.438 160.473 236.722 160.473H273.961C274.989 160.473 276.016 161.244 276.016 162.528C275.759 163.555 274.989 164.582 273.961 164.582Z",
    fill: "#E6EDF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M213.865 175.635C213.608 161.501 202.051 149.938 187.669 149.938H187.413C173.031 149.938 161.474 161.758 161.474 176.149C161.474 190.539 173.288 202.359 187.669 202.359C195.631 202.359 202.565 198.762 207.445 193.366C211.554 188.74 213.865 182.83 213.865 176.149C213.865 175.892 213.865 175.635 213.865 175.635ZM187.669 193.622C177.91 193.622 169.949 185.656 169.949 175.892C169.949 166.127 177.91 158.161 187.669 158.161H187.926C197.686 158.161 205.39 165.87 205.647 175.378C205.647 175.635 205.647 175.635 205.647 175.892C205.647 180.26 204.106 184.372 201.281 187.455C197.686 191.31 193.063 193.622 187.669 193.622Z",
    fill: "#E6EDF5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M213.865 175.635H205.39C205.133 166.127 197.428 158.418 187.669 158.418H187.412V149.938H187.669C202.051 149.938 213.608 161.244 213.865 175.635Z",
    fill: "#19AE57"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M213.865 175.892C213.865 182.573 211.554 188.483 207.445 193.109L201.024 187.712C203.849 184.629 205.39 180.517 205.39 176.149C205.39 175.892 205.39 175.892 205.39 175.635H213.865V175.892Z",
    fill: "#F7AD3C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.734 165.356C229.294 165.356 230.559 164.09 230.559 162.529C230.559 160.968 229.294 159.702 227.734 159.702C226.173 159.702 224.909 160.968 224.909 162.529C224.909 164.09 226.173 165.356 227.734 165.356Z",
    fill: "#E6EDF5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.961 176.403H236.722C235.695 176.403 234.668 175.633 234.668 174.349C234.668 173.321 235.438 172.294 236.722 172.294H273.961C274.989 172.294 276.016 173.064 276.016 174.349C275.759 175.376 274.989 176.403 273.961 176.403Z",
    fill: "#E6EDF5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M227.734 177.176C229.294 177.176 230.559 175.911 230.559 174.35C230.559 172.789 229.294 171.523 227.734 171.523C226.173 171.523 224.909 172.789 224.909 174.35C224.909 175.911 226.173 177.176 227.734 177.176Z",
    fill: "#B4BACA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M273.961 188.224H236.722C235.695 188.224 234.668 187.453 234.668 186.169C234.668 185.142 235.438 184.115 236.722 184.115H273.961C274.989 184.115 276.016 184.885 276.016 186.169C275.759 187.196 274.989 188.224 273.961 188.224Z",
    fill: "#E6EDF5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.734 188.997C229.294 188.997 230.559 187.731 230.559 186.17C230.559 184.609 229.294 183.344 227.734 183.344C226.173 183.344 224.909 184.609 224.909 186.17C224.909 187.731 226.173 188.997 227.734 188.997Z",
    fill: "#989FB0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.501 88.7788H276.016V42.7812L258.038 51.7752L248.536 58.4564L231.586 58.1994L216.69 65.9085L203.849 67.7073L199.226 72.8467L185.871 81.3267L172.774 83.6394L162.501 88.7788Z",
    fill: "#7647EE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M162.501 88.7789H276.016V53.831L258.038 60.5122L248.536 65.6516L231.586 65.3946L216.69 71.3049L203.849 72.8468L199.226 76.4443L185.871 83.1255L172.774 84.9243L162.501 88.7789Z",
    fill: "#F7AD3C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.501 88.7788H276.016V68.9921L258.038 72.8467L248.536 75.6733H231.586L216.69 78.757L203.849 79.7848L199.226 81.8406L185.871 85.4382L172.774 86.466L162.501 88.7788Z",
    fill: "#19AE57"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_9346",
    x: 0.333481,
    y: 17.8145,
    width: 318.572,
    height: 350.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.3333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_9346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_9346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_34_9346",
    x: 122.583,
    y: 9.59446,
    width: 315.083,
    height: 348.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.3333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_9346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_9346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_34_9346",
    x: 90.9933,
    y: 0.856506,
    width: 257.325,
    height: 314.172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.3333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_9346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_9346",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseAnalyticsEmptyState);
export default __webpack_public_path__ + "static/media/expenseAnalyticsEmptyState.54a6bf546f9b9497333307908a175e04.svg";
export { ForwardRef as ReactComponent };